import { Box, Stack } from "@mui/material";

const OuterBox = ({ children, sx = {}, spacing = 1, margin = 2, ...props }) => {
    return (
        <Box
            sx={{
                overflow: "auto",
                maxHeight: "99%",
                ...sx, // Allow additional styles to be passed
            }}
            {...props}
        >
            <Stack spacing={spacing} margin={margin}>
                {children}
            </Stack>
        </Box>
    );
};

export default OuterBox;